import { __read, __spreadArray, __values } from "tslib";
import { DestinationType, ProductQueryParam, ProductType, ProductTypeHelper, SearchMaskInputType, store } from 'ltur-state-engine';
// import {getQueryFromFormData} from './State';
import localeAction from 'Helper/localeAction';
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days';
import { FilterType } from "FilterBar/BaseFilterBar/Base/BaseFilterInterface";
var statePromise = import('./State');
var Analytics = /** @class */ (function () {
    function Analytics() {
    }
    Analytics.strip_html_tags = function (str) {
        if ((str === null) || (str === ''))
            return false;
        else
            str = str.toString();
        return str.replace(/<[^>]*>/g, '');
    };
    Analytics.offerValidationAsync = function (AvailabilityCheckResponse, product, ListItemNumber) {
        new Promise(function (resolve) {
            setTimeout(function () {
                Analytics.offerValidation(AvailabilityCheckResponse, product, ListItemNumber);
            }, 100);
        });
    };
    Analytics.offerValidation = function (AvailabilityCheckResponse, product, ListItemNumber) {
        var giataID = product.hotel.code;
        var pricePerPerson = AvailabilityCheckResponse.checkedPricePerPerson ? AvailabilityCheckResponse.checkedPricePerPerson.amount : null;
        var totalPrice = AvailabilityCheckResponse.checkedPrice ? AvailabilityCheckResponse.checkedPrice.amount : null;
        var originalPricePerPerson = AvailabilityCheckResponse.originalPricePerPerson ? AvailabilityCheckResponse.originalPricePerPerson.amount : null;
        var originalTotalPrice = AvailabilityCheckResponse.originalPrice ? AvailabilityCheckResponse.originalPrice.amount : null;
        var priceChange = totalPrice ? totalPrice - originalTotalPrice : 'noValue';
        var pricePerPersonChange = pricePerPerson ? pricePerPerson - originalPricePerPerson : 'noValue';
        var additionalOfferResponseData = product.references.bookingHref;
        var airlineOutbound = 'noValueExpected';
        var airlineInbound = 'noValueExpected';
        var departureAirportCodeInbound = 'noValueExpected';
        var departureAirportCodeOutbound = 'noValueExpected';
        var departureAirportNameInbound = 'noValueExpected';
        var departureAirportNameOutbound = 'noValueExpected';
        var arrivalAirportCodeInbound = 'noValueExpected';
        var arrivalAirportCodeOutbound = 'noValueExpected';
        var arrivalAirportNameInbound = 'noValueExpected';
        var arrivalAirportNameOutbound = 'noValueExpected';
        var departureDateTimeInbound = 'noValueExpected';
        var departureDateTimeOutbound = 'noValueExpected';
        var arrivalDateTimeInbound = 'noValueExpected';
        var arrivalDateTimeOutbound = 'noValueExpected';
        var durationOutbound = 'noValueExpected';
        var durationInbound = 'noValueExpected';
        var stopOverOutbound = 'noValueExpected';
        var stopOverInbound = 'noValueExpected';
        var FlightInfo = 'noValueExpected';
        var hotelCheckin = product.travelPeriod.arrivalDate ? product.travelPeriod.arrivalDate : '';
        var hotelCheckout = product.travelPeriod.returnDate ? product.travelPeriod.returnDate : '';
        var roomType = product.hotel.room.name ? product.hotel.room.name : '';
        var board = product.hotel.board.name ? product.hotel.board.name : '';
        var nights = product.travelPeriod.duration ? product.travelPeriod.duration : '';
        var HotelInfo = hotelCheckin + '_' + nights + '_' + roomType + '_' + board + '_' + hotelCheckout;
        if (product.flight !== undefined) {
            airlineOutbound = product.flight.outbound.airline.name;
            airlineInbound = product.flight.inbound.airline.name;
            departureAirportCodeInbound = product.flight.inbound.departureAirport.code;
            departureAirportCodeOutbound = product.flight.outbound.departureAirport.code;
            departureAirportNameInbound = product.flight.inbound.departureAirport.name;
            departureAirportNameOutbound = product.flight.outbound.departureAirport.name;
            arrivalAirportCodeInbound = product.flight.inbound.arrivalAirport.code;
            arrivalAirportCodeOutbound = product.flight.outbound.arrivalAirport.code;
            arrivalAirportNameInbound = product.flight.inbound.arrivalAirport.name;
            arrivalAirportNameOutbound = product.flight.outbound.arrivalAirport.name;
            departureDateTimeInbound = product.flight.inbound.departureDateTime;
            departureDateTimeOutbound = product.flight.outbound.departureDateTime;
            arrivalDateTimeInbound = product.flight.inbound.arrivalDateTime;
            arrivalDateTimeOutbound = product.flight.outbound.arrivalDateTime;
            durationOutbound = product.flight.outbound.duration;
            durationInbound = product.flight.inbound.duration;
            stopOverOutbound = product.flight.outbound.stopOver;
            if (product.flight.outbound.stopOver == 0) {
                stopOverOutbound = 'Direktflug';
            }
            stopOverInbound = product.flight.outbound.stopOver;
            if (product.flight.inbound.stopOver == 0) {
                stopOverInbound = 'Direktflug';
            }
            if (departureAirportCodeOutbound !== arrivalAirportCodeInbound || arrivalAirportCodeOutbound !== departureAirportCodeInbound) {
                var openJaw = true;
            }
            FlightInfo = airlineOutbound + '_' + departureAirportCodeOutbound + '_' + departureAirportNameOutbound + '_' + departureDateTimeOutbound + '_' + stopOverOutbound + '_' + durationOutbound + '_' + arrivalAirportCodeOutbound + '_' + arrivalAirportNameOutbound + '_' + arrivalDateTimeOutbound + '_' + airlineInbound + '_' + departureAirportCodeInbound + '_' + departureAirportNameInbound + '_' + departureDateTimeInbound + '_' + stopOverInbound + '_' + durationInbound + '_' + arrivalAirportCodeInbound + '_' + arrivalAirportNameInbound + '_' + arrivalDateTimeInbound;
        }
        var ErrorType = 'noValue';
        if (AvailabilityCheckResponse.availability == "UNAVAILABLE") {
            ErrorType = '';
            if (AvailabilityCheckResponse.messages != undefined) {
                for (var i = 0; i < AvailabilityCheckResponse.messages.length; i++) {
                    var message = AvailabilityCheckResponse.messages[i];
                    var ErrorCode = message.code;
                    var ErrorMessage = message.text;
                    if (i != 0) {
                        ErrorType += '#';
                    }
                    ErrorType += ErrorCode + ' ' + ErrorMessage;
                }
            }
            else {
                ErrorType = 'noValue';
            }
        }
        dataLayer.push({
            'event': 'offerValidation',
            'eventCategory': 'OfferValidation',
            'eventAction': giataID,
            'listItemNumber': ListItemNumber + 1,
            'ErrorCode': ErrorType,
            'offerDescription': '',
            'flightInfo': FlightInfo,
            'hotelInfo': HotelInfo,
            'departureAirportCode': departureAirportCodeOutbound,
            'destinationCode': arrivalAirportCodeOutbound,
            'pricePerPerson': pricePerPerson,
            'totalPrice': totalPrice,
            'totalPriceChange': priceChange,
            'pricePerPersonChange': pricePerPersonChange,
            'additionalOfferResponseData': additionalOfferResponseData,
        });
    };
    Analytics.bindNaviClickAsync = function () {
        new Promise(function (resolve) {
            setTimeout(function () {
                Analytics.bindNaviClick();
            }, 100);
        });
    };
    Analytics.bindNaviClick = function () {
        var naviType = 'Haupt-Navi';
        var menuItems = document.querySelectorAll('[data-analytics_navi]');
        Analytics.setEvents(naviType, menuItems);
    };
    Analytics.bindSubNaviClick = function () {
        var naviType = 'Haupt-Navi';
        var menuItems = document.querySelectorAll('.c-burger-menu [data-analytics_navi]');
        Analytics.setEvents(naviType, menuItems);
    };
    Analytics.bindSatelliteNaviClick = function () {
        var naviType = 'Haupt-Navi';
        var menuItems = document.querySelectorAll('.c-nav-primary__list--satellite [data-analytics_navi]');
        Analytics.setEvents(naviType, menuItems);
    };
    Analytics.setEvents = function (naviType, menuItems) {
        function naviClick(eventAction, eventLabel, targetUrl) {
            dataLayer.push({
                'event': 'ga_naviClick',
                'eventCategory': 'Navigation geklickt',
                'eventAction': eventAction ? eventAction.trim() : '',
                'eventLabel': eventLabel ? Analytics.strip_html_tags(eventLabel.trim()) : '',
                'targetURL': targetUrl ? targetUrl.trim() : ''
            });
        }
        var _loop_1 = function (i) {
            var menuItem = menuItems[i];
            //@ts-ignore
            menuItem.addEventListener("click", function () { naviClick(naviType, menuItem.dataset.analytics_navi, menuItem.getAttribute("href")); });
        };
        for (var i = 0; i < menuItems.length; i++) {
            _loop_1(i);
        }
    };
    Analytics.bindFooterClickAsync = function () {
        new Promise(function (resolve) {
            setTimeout(function () {
                Analytics.bindFooterClick();
            }, 100);
        });
    };
    Analytics.bindFooterClick = function () {
        var footerType = 'Footer-Navi';
        var footerItems = document.querySelectorAll('[data-analytics_footer]');
        function footerClick(eventAction, eventLabel, targetUrl) {
            dataLayer.push({
                'event': 'ga_naviClick',
                'eventCategory': 'Navigation geklickt',
                'eventAction': eventAction ? eventAction.trim() : '',
                'eventLabel': eventLabel ? Analytics.strip_html_tags(eventLabel.trim()) : '',
                'targetURL': targetUrl ? targetUrl.trim() : ''
            });
        }
        var _loop_2 = function (i) {
            var footerItem = footerItems[i];
            //@ts-ignore
            footerItem.addEventListener("click", function () { footerClick(footerType, footerItem.dataset.analytics_footer, footerItem.getAttribute("href")); });
        };
        for (var i = 0; i < footerItems.length; i++) {
            _loop_2(i);
        }
    };
    Analytics.bindTabClickAsync = function () {
        new Promise(function (resolve) {
            setTimeout(function () {
                Analytics.bindTabClick();
            }, 100);
        });
    };
    Analytics.bindTabClick = function () {
        var tabsWrapper = document.getElementById('tabsWrapper');
        var tabs = tabsWrapper.getElementsByTagName('label');
        var path = window.location.pathname;
        var pathSegments = path.split('/');
        var lastPathSegment = pathSegments[pathSegments.length - 1];
        var hotelInformation = lastPathSegment.split('-');
        var giataId = parseInt(hotelInformation[hotelInformation.length - 1]);
        function tabClick(eventAction) {
            dataLayer.push({
                event: 'ga_hotelTabClicked',
                eventCategory: 'Hotel-Tab geklickt',
                eventAction: eventAction ? eventAction.trim() : '',
                eventLabel: giataId ? giataId : ''
            });
        }
        var _loop_3 = function (i) {
            var tab = tabs[i];
            tab.addEventListener("click", function () { tabClick(tab.textContent); });
        };
        for (var i = 0; i < tabs.length; i++) {
            _loop_3(i);
        }
    };
    Analytics.getExtendedSearchDataLayerAsync = function () {
        new Promise(function (resolve) {
            setTimeout(function () {
                Analytics.getExtendedSearchDataLayer();
            }, 100);
        });
    };
    Analytics.getExtendedSearchDataLayer = function () {
        var lturState = store.getState();
        var activeTab = lturState.websiteState.searchMask.searchMaskActiveTab;
        dataLayer.push({
            'event': 'ga_searchMaskExtendedClick',
            'eventLabel': activeTab ? activeTab : ''
        });
    };
    Analytics.getNoHotelImageAsync = function () {
        new Promise(function (resolve) {
            setTimeout(function () {
                Analytics.getNoHotelImage();
            }, 100);
        });
    };
    Analytics.isValueInDatalayer = function ($key, $val) {
        var res = -1;
        var dlname;
        var item = 0;
        //@ts-ignore
        for (item in window.google_tag_manager) {
            //@ts-ignore
            if (typeof (window.google_tag_manager[item]) == "object" && window.google_tag_manager[item].gtmDom)
                dlname = item;
        }
        //@ts-ignore
        if (typeof (window.google_tag_manager) != "undefined") {
            for (item in window[dlname]) {
                if (!$val && $val != '') {
                    if (window[dlname][item][$key]) {
                        return item;
                    }
                }
                else {
                    if (window[dlname][item][$key] && window[dlname][item][$key] == $val) {
                        return item;
                    }
                }
            }
        }
        return res != -1;
    };
    ;
    Analytics.waitForElm = function (selector) {
        return new Promise(function (resolve) {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
            var observer = new MutationObserver(function (mutations) {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    };
    Analytics.getNoHotelImage = function () {
        var _a;
        var HotelListName = document.getElementsByClassName('c-hotellist-control-box__title')[0].childNodes[0].textContent;
        var HotelImages = document.getElementsByTagName('hotel-gallery-ui');
        for (var i = 0; i < HotelImages.length; i++) {
            var HotelImage = HotelImages[i];
            //@ts-ignore
            if ((_a = HotelImage.getAttribute('data')) === null || _a === void 0 ? void 0 : _a.includes('{"media":[]')) {
                //@ts-ignore
                var hotelURL = HotelImage.parentElement.parentElement ? HotelImage.parentElement.parentElement.dataset.url : '';
                var urlParts = hotelURL ? hotelURL.split('?')[0].split('-') : '';
                var hotelCode = urlParts ? urlParts[urlParts.length - 1] : '';
                var eventData = {
                    'event': 'hotel_dummyPic',
                    'event_name': 'hotel_dummyPic',
                    'hotel_dummyPic': {
                        'eventCategory': 'hotel_dummyPic',
                        'eventAction': hotelCode,
                        'eventLabel': HotelListName
                    }
                };
                //@ts-ignore
                if (typeof cookieConsentUpdated !== 'undefined' && cookieConsentUpdated) {
                    if (typeof dataLayer !== 'undefined') {
                        dataLayer.push(eventData);
                    }
                }
                else {
                    //@ts-ignore
                    if (typeof dataLayerTemp !== 'undefined') {
                        //@ts-ignore
                        dataLayerTemp.push(eventData);
                    }
                }
            }
        }
    };
    Analytics.getDataLayerAsync = function (event, destinationType) {
        if (destinationType === void 0) { destinationType = null; }
        new Promise(function (resolve) {
            setTimeout(function () {
                Analytics.getDataLayer(event, destinationType);
            }, 100);
        });
    };
    Analytics.getNoHotelImageHD = function (destinationType) {
        var PagePath = document.location.href;
        var HotelImages = document.getElementsByTagName('hotel-gallery-ui');
        for (var i = 0; i < HotelImages.length; i++) {
            var HotelImage = HotelImages[i];
            var data = HotelImage.getAttribute('data') || '';
            //@ts-ignore
            if (data == '{"media":[]}' || data.includes('placeholder') || data.includes('dummy')) {
                //@ts-ignore
                var urlParts = PagePath ? PagePath.split('?')[0].split('-') : '';
                var giataID = urlParts ? urlParts[urlParts.length - 1] : '';
                var hotelCode = '';
                var lturState = store.getState();
                var storageKey = 'default';
                //@ts-ignore
                var productType = lturState.websiteState.app.url.context.productType;
                var coreStateGroup = ProductTypeHelper.mapToCoreStateGroup(productType);
                var products = null;
                if (productType == ProductType.HOTEL) {
                    if (destinationType == DestinationType.HOTEL_LIST) {
                        //@ts-ignore
                        products = lturState.coreState[coreStateGroup].products.get(destinationType).products;
                        //@ts-ignore
                    }
                    else if (destinationType == DestinationType.DESTINATION && lturState.coreState[coreStateGroup].groups.get(destinationType).productGroups) {
                        //@ts-ignore
                        products = lturState.coreState[coreStateGroup].groups.get(destinationType).productGroups[0].products;
                    }
                    else {
                        //@ts-ignore
                        products = lturState.coreState[coreStateGroup].offers.get(storageKey).products;
                    }
                }
                else if (destinationType == DestinationType.HOTEL_LIST) {
                    //@ts-ignore
                    products = lturState.coreState[coreStateGroup].products.get(destinationType).products;
                }
                else if (destinationType == DestinationType.DESTINATION) {
                    //@ts-ignore
                    if (lturState.coreState[coreStateGroup].groups.get(destinationType).productGroups) {
                        //@ts-ignore
                        products = lturState.coreState[coreStateGroup].groups.get(destinationType).productGroups[0].products;
                    }
                }
                else {
                    //@ts-ignore
                    products = lturState.coreState[coreStateGroup].flightAlternatives.get(storageKey).products;
                }
                //@ts-ignore
                if (products[0].hotel) {
                    //@ts-ignore
                    hotelCode = products[0].hotel.productCode;
                }
                var eventData = {
                    'event': 'hotel_dummyPic',
                    'event_name': 'hotel_dummyPic',
                    'hotel_dummyPic': {
                        'eventCategory': 'hotel_dummyPic',
                        'eventAction': giataID,
                        'eventLabel': hotelCode
                    }
                };
                //@ts-ignore
                if (typeof cookieConsentUpdated !== 'undefined' && cookieConsentUpdated) {
                    if (typeof dataLayer !== 'undefined') {
                        dataLayer.push(eventData);
                    }
                }
                else {
                    //@ts-ignore
                    if (typeof dataLayerTemp !== 'undefined') {
                        //@ts-ignore
                        dataLayerTemp.push(eventData);
                    }
                }
            }
        }
    };
    Analytics.getDataLayer = function (event, destinationType) {
        if (destinationType === void 0) { destinationType = null; }
        statePromise.then(function (module) {
            var lturState = store.getState();
            var storageKey = 'default';
            var products = null;
            var productType = lturState.websiteState.app.url.context.productType;
            var coreStateGroup = ProductTypeHelper.mapToCoreStateGroup(productType);
            var searchMaskGroupType = ProductTypeHelper.mapToSearchMaskGroupType(productType);
            var searchMaskGroup = JSON.parse(JSON.stringify(lturState.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType]));
            var searchMaskInput = searchMaskGroup.inputs[SearchMaskInputType.TRAVEL_PERIOD];
            var currentDate = new Date();
            var giataID = null;
            var hotelName = null;
            if (searchMaskGroup.inputs[SearchMaskInputType.DESTINATION].confirmedValue.value.reference) {
                giataID = searchMaskGroup.inputs[SearchMaskInputType.DESTINATION].confirmedValue.value.reference.value ? searchMaskGroup.inputs[SearchMaskInputType.DESTINATION].confirmedValue.value.reference.value : 'noValue';
            }
            if (giataID !== null) {
                hotelName = searchMaskGroup.inputs[SearchMaskInputType.DESTINATION].confirmedValue.value.value;
            }
            var departureAirport = null;
            var departureAirportCode = null;
            var destinationName = null;
            var destinationCode = null;
            var returnAirportName = null;
            var returnAirportCode = null;
            var airlineCodeDeparting = null;
            var airlineCodeReturning = null;
            var destination = null;
            var destinationCountry = null;
            var boardId = searchMaskGroup.inputs[SearchMaskInputType.HOTEL_BOARD_CODES].confirmedValue.value;
            var boardCodes = boardId ? module.getQueryFromFormData(boardId) : [];
            var board = boardCodes['HOTEL_BOARD_CODES'] ? boardCodes['HOTEL_BOARD_CODES'][0] : 'beliebig';
            var productCode = null;
            var hotelRatingQualifier = null;
            var hotelRecommendationPercentage = null;
            var hotelCategory = null;
            var selectedSortValue = null;
            var lowestPrice = 'noValue';
            var lowestPriceTotal = 'noValue';
            var giataId01 = null;
            var giataId02 = null;
            var giataId03 = null;
            var giataId04 = null;
            var giataId05 = null;
            var giataId06 = null;
            var giataId07 = null;
            var giataId08 = null;
            var giataId09 = null;
            var giataId10 = null;
            var departureDate = searchMaskGroup.inputs[SearchMaskInputType.TRAVEL_PERIOD].confirmedValue.value.departureDate;
            var returnDate = searchMaskGroup.inputs[SearchMaskInputType.TRAVEL_PERIOD].confirmedValue.value.returnDate;
            var dateOfTravelStartOfferResponse = null;
            var dateOfTravelEndOfferResponse = null;
            //const daysToTravelStart = differenceInCalendarDays(departureDate, currentDate);
            var travellersAdults = searchMaskGroup.inputs[SearchMaskInputType.TRAVELLERS].confirmedValue.value.adults;
            var noOfChildrenAndToddlers = searchMaskGroup.inputs[SearchMaskInputType.TRAVELLERS].confirmedValue.value.ageOfChildrenLength;
            var noOfToddlers = 0;
            for (var child in searchMaskGroup.inputs[SearchMaskInputType.TRAVELLERS].confirmedValue.value.ageOfChildren) {
                if (searchMaskGroup.inputs[SearchMaskInputType.TRAVELLERS].confirmedValue.value.ageOfChildren[child] < 2) {
                    noOfToddlers = noOfToddlers + 1;
                }
            }
            var duration = searchMaskInput.coreQuery[ProductQueryParam.TRAVEL_PERIOD_DURATION];
            if (duration) {
                var durationString = '' + duration;
                var durationMin = parseInt(durationString.substr(1, 2), 10);
                var durationMax = parseInt(durationString.substr(3, 2), 10);
                if (searchMaskInput.confirmedValue.value.exactDuration) {
                    if (departureDate && returnDate) {
                        duration = differenceInCalendarDays(returnDate, departureDate);
                    }
                }
                else {
                    if (durationMax === durationMin) {
                        duration = durationMin;
                    }
                    else {
                        if (durationMax < durationMin) {
                            durationMax = 99;
                        }
                        duration = durationMin + '-' + durationMax;
                    }
                }
            }
            if (productType == ProductType.HOTEL) {
                if (destinationType == DestinationType.HOTEL_LIST) {
                    products = lturState.coreState[coreStateGroup].products.get(destinationType).products;
                }
                else if (destinationType == DestinationType.DESTINATION && lturState.coreState[coreStateGroup].groups.get(destinationType).productGroups) {
                    products = lturState.coreState[coreStateGroup].groups.get(destinationType).productGroups[0].products;
                }
                else {
                    products = lturState.coreState[coreStateGroup].offers.get(storageKey).products;
                }
            }
            else if (destinationType == DestinationType.HOTEL_LIST) {
                products = lturState.coreState[coreStateGroup].products.get(destinationType).products;
            }
            else if (destinationType == DestinationType.DESTINATION) {
                if (lturState.coreState[coreStateGroup].groups.get(destinationType).productGroups) {
                    products = lturState.coreState[coreStateGroup].groups.get(destinationType).productGroups[0].products;
                }
            }
            else {
                products = lturState.coreState[coreStateGroup].flightAlternatives.get(storageKey).products;
            }
            if (destinationType == DestinationType.HOTEL_LIST || destinationType == null) {
                if (products && products[0]) {
                    selectedSortValue = searchMaskGroup.inputs[SearchMaskInputType.PAGINATION].confirmedValue.value.sorting[0];
                }
                else {
                    selectedSortValue = 'noValue';
                }
            }
            if (destinationType == DestinationType.DESTINATION || destinationType == DestinationType.HOTEL_LIST || !products) {
                destination = searchMaskGroup.inputs[SearchMaskInputType.DESTINATION].confirmedValue.value[0] ? searchMaskGroup.inputs[SearchMaskInputType.DESTINATION].confirmedValue.value[0].name : searchMaskGroup.inputs[SearchMaskInputType.DESTINATION].confirmedValue.uiValue;
                destination = destination.toLowerCase();
                if (productType != ProductType.HOTEL) {
                    departureAirport = searchMaskGroup.inputs[SearchMaskInputType.DEPARTURE_AIRPORT].confirmedValue.value[0] ? searchMaskGroup.inputs[SearchMaskInputType.DEPARTURE_AIRPORT].confirmedValue.value[0].name : searchMaskGroup.inputs[SearchMaskInputType.DEPARTURE_AIRPORT].confirmedValue.uiValue;
                    departureAirportCode = searchMaskGroup.inputs[SearchMaskInputType.DEPARTURE_AIRPORT].confirmedValue.value[0] ? searchMaskGroup.inputs[SearchMaskInputType.DEPARTURE_AIRPORT].confirmedValue.value[0].code : null;
                    var departureAirportCodes = searchMaskGroup.inputs[SearchMaskInputType.DEPARTURE_AIRPORT].confirmedValue.value[0] ? searchMaskGroup.inputs[SearchMaskInputType.DEPARTURE_AIRPORT].confirmedValue.value[0].airports : null;
                    if (departureAirportCodes != null) {
                        departureAirportCode = departureAirportCodes[0].code;
                        for (var code in departureAirportCodes) {
                            departureAirportCode = departureAirportCode + ',' + departureAirportCodes[code].code;
                        }
                    }
                }
            }
            if (products && products[0]) {
                lowestPrice = (Math.round(products[0].price.amountPerPerson * 100) / 100).toFixed(2);
                lowestPriceTotal = (Math.round(products[0].price.amountTotal * 100) / 100).toFixed(2);
                //@ts-ignore
                if (products[0].flight && destinationType != DestinationType.DESTINATION) {
                    if (destinationType != DestinationType.HOTEL_LIST) {
                        //@ts-ignore
                        departureAirport = products[0].flight.outbound.departureAirport.name;
                        //@ts-ignore
                        departureAirportCode = products[0].flight.outbound.departureAirport.code;
                    }
                    //@ts-ignore
                    destinationName = products[0].flight.outbound.arrivalAirport.name;
                    //@ts-ignore
                    destinationCode = products[0].flight.outbound.arrivalAirport.code;
                    //@ts-ignore
                    returnAirportName = products[0].flight.inbound.arrivalAirport.name;
                    //@ts-ignore
                    returnAirportCode = products[0].flight.inbound.arrivalAirport.code;
                    //@ts-ignore
                    airlineCodeDeparting = products[0].flight.outbound.airline.code;
                    //@ts-ignore
                    airlineCodeReturning = products[0].flight.inbound.airline.code;
                }
                if (products[0].hotel) {
                    if (destinationType == 'HOTEL_DETAIL') {
                        productCode = products[0].hotel.productCode;
                        board = products[0].hotel.board.code;
                        hotelCategory = products[0].hotel.category;
                        if (products[0].hotel.recommendations) {
                            hotelRatingQualifier = products[0].hotel.recommendations.OVERALL_AVERAGE_RATING;
                            hotelRecommendationPercentage = products[0].hotel.recommendations.RECOMMENDATIONS_TOTAL;
                        }
                        destination = products[0].hotel.location.region.name ? products[0].hotel.location.region.name.toLowerCase() : 'noValue';
                        destinationCountry = products[0].hotel.location.country.name ? products[0].hotel.location.country.name : 'noValue';
                        dateOfTravelStartOfferResponse = products[0].travelPeriod.departureDate ? products[0].travelPeriod.departureDate : 'noValue';
                        dateOfTravelEndOfferResponse = products[0].travelPeriod.returnDate ? products[0].travelPeriod.returnDate : 'noValue';
                    }
                }
                if (destinationType != null && destinationType == DestinationType.HOTEL_LIST) {
                    giataId01 = products[0] ? products[0].hotel.code : 'noValue';
                    giataId02 = products[1] ? products[1].hotel.code : 'noValue';
                    giataId03 = products[2] ? products[2].hotel.code : 'noValue';
                    giataId04 = products[3] ? products[3].hotel.code : 'noValue';
                    giataId05 = products[4] ? products[4].hotel.code : 'noValue';
                    giataId06 = products[5] ? products[5].hotel.code : 'noValue';
                    giataId07 = products[6] ? products[6].hotel.code : 'noValue';
                    giataId08 = products[7] ? products[7].hotel.code : 'noValue';
                    giataId09 = products[8] ? products[8].hotel.code : 'noValue';
                    giataId10 = products[9] ? products[9].hotel.code : 'noValue';
                }
                else {
                    giataId01 = null;
                    giataId02 = null;
                    giataId03 = null;
                    giataId04 = null;
                    giataId05 = null;
                    giataId06 = null;
                    giataId07 = null;
                    giataId08 = null;
                    giataId09 = null;
                    giataId10 = null;
                }
            }
            else {
                lowestPrice = 'noOffer';
                lowestPriceTotal = 'noOffer';
                dateOfTravelStartOfferResponse = 'noValue';
                dateOfTravelEndOfferResponse = 'noValue';
                destination = 'noValue';
                destinationCountry = 'noValue';
                board = 'noValue';
            }
            if (destination == 'beliebig' || destination == 'peu importe') {
                destination = 'beliebig';
            }
            if (duration == 0) {
                duration = 'beliebig';
            }
            var eventData = {
                'event': event,
                'Zielort': destination,
                'Zielland': destinationCountry,
                'GiataID': giataID,
                'hotelLturCode': productCode,
                'hotelName': hotelName,
                'hotelCategory': hotelCategory,
                'hotelRating': hotelRatingQualifier,
                'hotelRecommendationPercentage': hotelRecommendationPercentage,
                'Verpflegung': board,
                'departureAirportName': departureAirport,
                'departureAirportCode': departureAirportCode,
                'destinationName': destinationName,
                'destinationCode': destinationCode,
                'returnAirportName': returnAirportName,
                'returnAirportCode': returnAirportCode,
                'airlineCodeDeparting': airlineCodeDeparting,
                'airlineCodeReturning': airlineCodeReturning,
                'dateOfTravelStart': departureDate,
                'dateOfTravelEnd': returnDate,
                'dateOfTravelStartOfferResponse': dateOfTravelStartOfferResponse,
                'dateOfTravelEndOfferResponse': dateOfTravelEndOfferResponse,
                'duration': duration,
                'travellersAdults': travellersAdults,
                'noOfChildrenAndToddlers': noOfChildrenAndToddlers,
                'noOfToddlers': noOfToddlers,
                'lowestPrice': lowestPrice,
                'lowestPriceTotal': lowestPriceTotal,
                'GiataID01': giataId01,
                'GiataID02': giataId02,
                'GiataID03': giataId03,
                'GiataID04': giataId04,
                'GiataID05': giataId05,
                'GiataID06': giataId06,
                'GiataID07': giataId07,
                'GiataID08': giataId08,
                'GiataID09': giataId09,
                'GiataID10': giataId10,
                'hotelListSorting': selectedSortValue
            };
            //@ts-ignore
            if (typeof cookieConsentUpdated !== 'undefined' && cookieConsentUpdated) {
                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push(eventData);
                }
            }
            else {
                //@ts-ignore
                if (typeof dataLayerTemp !== 'undefined') {
                    //@ts-ignore
                    dataLayerTemp.push(eventData);
                }
            }
        });
    };
    Analytics.getProdImpressionPA_HLPAsync = function (eecProducts) {
        new Promise(function (resolve) {
            setTimeout(function () {
                Analytics.getProdImpressionPA_HLP(eecProducts);
            }, 100);
        });
    };
    Analytics.getProdImpressionPA_HLP_ET = function (eecProducts) {
        var date = new Date();
        dataLayer.push({
            'event': 'eecProdImpressionPA_HLP-ET',
            'eventCategory': 'EEC',
            'eventAction': 'Product Impression HLP-ET',
            'eventLabel': date.getFullYear() + '-' + (date.getMonth() + 1),
            'ecommerce': {
                'currencyCode': 'EUR',
                'impressions': eecProducts
            }
        });
    };
    Analytics.getProdImpressionHT_HLP_ET = function (eecProducts) {
        var date = new Date();
        dataLayer.push({
            'event': 'eecProdImpressionHT_HLP-ET',
            'eventCategory': 'EEC',
            'eventAction': 'Product Impression HLP-ET',
            'eventLabel': date.getFullYear() + '-' + (date.getMonth() + 1),
            'ecommerce': {
                'currencyCode': 'EUR',
                'impressions': eecProducts
            }
        });
    };
    Analytics.getProdImpressionPA_HLP = function (eecProducts) {
        var date = new Date();
        var tagmanagerPromise = new Promise(function (tagManagerResolve) {
            setTimeout(function () {
                //@ts-ignore
                if (window.google_tag_manager != undefined) {
                    //@ts-ignore
                    var impressions = window.google_tag_manager['GTM-MWCRQ4'].dataLayer.get('ecommerce.impressions');
                    if (impressions != undefined) {
                        impressions = __spreadArray(__spreadArray([], __read(impressions), false), __read(eecProducts), false);
                    }
                    else {
                        impressions = eecProducts;
                    }
                    tagManagerResolve(impressions);
                }
            }, 100);
        });
        tagmanagerPromise.then(function (impressions) {
            dataLayer.push({
                'event': 'eecProdImpressionPA_HLP',
                'eventCategory': 'EEC',
                'eventAction': 'Product Impression HLP',
                'eventLabel': date.getFullYear() + '-' + (date.getMonth() + 1),
                'ecommerce': {
                    'currencyCode': 'EUR',
                    'impressions': impressions
                }
            });
        });
    };
    Analytics.getProdImpressionHT_HLP = function (eecProducts) {
        var date = new Date();
        var tagmanagerPromise = new Promise(function (tagManagerResolve) {
            setTimeout(function () {
                //@ts-ignore
                if (window.google_tag_manager != undefined) {
                    //@ts-ignore
                    var impressions = window.google_tag_manager['GTM-MWCRQ4'].dataLayer.get('ecommerce.impressions');
                    if (impressions != undefined) {
                        impressions = __spreadArray(__spreadArray([], __read(impressions), false), __read(eecProducts), false);
                    }
                    else {
                        impressions = eecProducts;
                    }
                    tagManagerResolve(impressions);
                }
            }, 100);
        });
        tagmanagerPromise.then(function (impressions) {
            dataLayer.push({
                'event': 'eecProdImpressionHT_HLP',
                'eventCategory': 'EEC',
                'eventAction': 'Product Impression HLP',
                'eventLabel': date.getFullYear() + '-' + (date.getMonth() + 1),
                'ecommerce': {
                    'currencyCode': 'EUR',
                    'impressions': impressions
                }
            });
        });
    };
    Analytics.normalizeProduct = function (product, page, noPosition) {
        if (noPosition === void 0) { noPosition = false; }
        var eecProduct = {};
        if (product.hasOwnProperty('flight')) {
            eecProduct['dimension19'] = Analytics.normalizePackageDimension19(product);
            eecProduct['dimension82'] = Analytics.normalizePackageDimension82(product);
            eecProduct['dimension2'] = Analytics.normalizeDimension2(product);
            eecProduct['dimension34'] = Analytics.normalizeDimension34(product);
            eecProduct['dimension136'] = Analytics.normalizeDimension136(product);
            eecProduct['dimension135'] = Analytics.normalizeDimension135(product);
            eecProduct['dimension35'] = Analytics.normalizeDimension35(product);
            eecProduct['dimension81'] = Analytics.normalizeDimension81(product);
            eecProduct['dimension78'] = Analytics.normalizeDimension78(product);
            eecProduct['dimension37'] = Analytics.normalizeDimension37(product);
            eecProduct['dimension74'] = Analytics.normalizeDimension74(product);
            eecProduct['dimension138'] = Analytics.normalizeDimension138(product);
            eecProduct['dimension38'] = Analytics.normalizeDimension38(product);
            eecProduct['dimension32'] = Analytics.normalizeDimension32(product);
            eecProduct['dimension29'] = Analytics.normalizeDimension29(product);
            eecProduct['dimension24'] = Analytics.normalizeDimension24(product);
            eecProduct['dimension33'] = Analytics.normalizeDimension33(product);
            eecProduct['dimension26'] = Analytics.normalizeDimension26(product);
            eecProduct['dimension140'] = Analytics.normalizeDimension140(product);
            eecProduct['dimension27'] = Analytics.normalizeDimension27(product);
            eecProduct['dimension141'] = Analytics.normalizeDimension141(product);
            eecProduct['dimension28'] = Analytics.normalizeDimension28(product);
            eecProduct['dimension70'] = Analytics.normalizeDimension70(product);
            eecProduct['dimension56'] = Analytics.normalizeDimension56(product);
            eecProduct['dimension67'] = Analytics.normalizeDimension67(product);
            eecProduct['dimension42'] = Analytics.normalizeDimension42(product);
            eecProduct['dimension53'] = Analytics.normalizeDimension53(product);
            eecProduct['brand'] = Analytics.normalizeBrand(product);
            eecProduct['category'] = Analytics.normalizeCategory(product);
            eecProduct['currency code'] = Analytics.normalizeCurrencyCode(product);
            eecProduct['id'] = Analytics.normalizeId(product);
            eecProduct['internalId'] = Analytics.normalizeInternalId(product);
            eecProduct['item_list_id'] = Analytics.normalizeList();
            eecProduct['item_list_name'] = Analytics.normalizeList();
            eecProduct['name'] = Analytics.normalizeName(product);
            eecProduct['position'] = noPosition ? 0 : Analytics.normalizePosition(product);
            eecProduct['dimension86'] = Analytics.normalizeDimension86(product);
            eecProduct['dimension18'] = Analytics.normalizeDimension18(product);
            eecProduct['dimension22'] = Analytics.normalizeDimension22(product);
            eecProduct['dimension142'] = Analytics.normalizeDimension142(product);
            eecProduct['dimension89'] = Analytics.normalizeDimension89(product);
            eecProduct['dimension20'] = Analytics.normalizePackageDimension20(product);
            eecProduct['dimension16'] = Analytics.normalizeDimension16(product);
            eecProduct['dimension13'] = Analytics.normalizeDimension13(product);
            eecProduct['dimension52'] = Analytics.normalizeDimension52(product);
            eecProduct['dimension15'] = Analytics.normalizeDimension15(product);
            eecProduct['dimension147'] = Analytics.normalizeDimension147(product, page);
            eecProduct['price'] = Analytics.normalizePrice(product);
        }
        else {
            eecProduct['dimension19'] = Analytics.normalizeHotelDimension19(product);
            eecProduct['dimension82'] = Analytics.normalizeHotelDimension82(product);
            eecProduct['dimension2'] = Analytics.normalizeDimension2(product);
            eecProduct['dimension32'] = Analytics.normalizeDimension32(product);
            eecProduct['dimension29'] = Analytics.normalizeDimension29(product);
            eecProduct['dimension24'] = Analytics.normalizeDimension24(product);
            eecProduct['dimension33'] = Analytics.normalizeDimension33(product);
            eecProduct['dimension26'] = Analytics.normalizeDimension26(product);
            eecProduct['dimension140'] = Analytics.normalizeDimension140(product);
            eecProduct['dimension27'] = Analytics.normalizeDimension27(product);
            eecProduct['dimension141'] = Analytics.normalizeDimension141(product);
            eecProduct['dimension28'] = Analytics.normalizeDimension28(product);
            eecProduct['dimension70'] = Analytics.normalizeDimension70(product);
            eecProduct['dimension56'] = Analytics.normalizeDimension56(product);
            eecProduct['dimension67'] = Analytics.normalizeDimension67(product);
            eecProduct['dimension42'] = Analytics.normalizeDimension42(product);
            eecProduct['brand'] = Analytics.normalizeBrand(product);
            eecProduct['category'] = Analytics.normalizeCategory(product);
            eecProduct['currency code'] = Analytics.normalizeCurrencyCode(product);
            eecProduct['id'] = Analytics.normalizeId(product);
            eecProduct['internalId'] = Analytics.normalizeInternalId(product);
            eecProduct['item_list_id'] = Analytics.normalizeList();
            eecProduct['item_list_name'] = Analytics.normalizeList();
            eecProduct['name'] = Analytics.normalizeName(product);
            eecProduct['position'] = noPosition ? 0 : Analytics.normalizePosition(product);
            eecProduct['dimension86'] = Analytics.normalizeDimension86(product);
            eecProduct['dimension18'] = Analytics.normalizeDimension18(product);
            eecProduct['dimension22'] = Analytics.normalizeDimension22(product);
            eecProduct['dimension142'] = Analytics.normalizeDimension142(product);
            eecProduct['dimension89'] = Analytics.normalizeDimension89(product);
            eecProduct['dimension20'] = Analytics.normalizeHotelDimension20(product);
            eecProduct['dimension16'] = Analytics.normalizeDimension16(product);
            eecProduct['dimension13'] = Analytics.normalizeDimension13(product);
            eecProduct['dimension52'] = Analytics.normalizeDimension52(product);
            eecProduct['dimension15'] = Analytics.normalizeDimension15(product);
            eecProduct['dimension147'] = Analytics.normalizeDimension147(product, page);
            eecProduct['price'] = Analytics.normalizePrice(product);
        }
        return eecProduct;
    };
    Analytics.normalizeFlightAlternatives = function (product, page) {
        var eecFlightAlternative = {};
        eecFlightAlternative['dimension19'] = Analytics.normalizePackageDimension19(product);
        eecFlightAlternative['dimension82'] = Analytics.normalizePackageDimension82(product);
        eecFlightAlternative['dimension2'] = Analytics.normalizeDimension2(product);
        eecFlightAlternative['dimension34'] = Analytics.normalizeDimension34(product);
        eecFlightAlternative['dimension136'] = Analytics.normalizeDimension136(product);
        eecFlightAlternative['dimension135'] = Analytics.normalizeDimension135(product);
        eecFlightAlternative['dimension35'] = Analytics.normalizeDimension35(product);
        eecFlightAlternative['dimension81'] = Analytics.normalizeDimension81(product);
        eecFlightAlternative['dimension78'] = Analytics.normalizeDimension78(product);
        eecFlightAlternative['dimension37'] = Analytics.normalizeDimension37(product);
        eecFlightAlternative['dimension74'] = Analytics.normalizeDimension74(product);
        eecFlightAlternative['dimension138'] = Analytics.normalizeDimension138(product);
        eecFlightAlternative['dimension38'] = Analytics.normalizeDimension38(product);
        eecFlightAlternative['dimension32'] = Analytics.normalizeDimension32(product);
        eecFlightAlternative['dimension29'] = Analytics.normalizeDimension29(product);
        eecFlightAlternative['dimension24'] = Analytics.normalizeDimension24(product);
        eecFlightAlternative['dimension33'] = Analytics.normalizeDimension33(product);
        eecFlightAlternative['dimension26'] = Analytics.normalizeDimension26(product);
        eecFlightAlternative['dimension140'] = Analytics.normalizeDimension140(product);
        eecFlightAlternative['dimension27'] = Analytics.normalizeDimension27(product);
        eecFlightAlternative['dimension141'] = Analytics.normalizeDimension141(product);
        eecFlightAlternative['dimension28'] = Analytics.normalizeDimension28(product);
        eecFlightAlternative['dimension70'] = Analytics.normalizeDimension70(product);
        eecFlightAlternative['dimension56'] = Analytics.normalizeDimension56(product);
        eecFlightAlternative['dimension67'] = Analytics.normalizeDimension67(product);
        eecFlightAlternative['dimension42'] = Analytics.normalizeDimension42(product);
        eecFlightAlternative['dimension53'] = Analytics.normalizeDimension53(product);
        eecFlightAlternative['brand'] = Analytics.normalizeBrand(product);
        eecFlightAlternative['category'] = Analytics.normalizeCategory(product);
        eecFlightAlternative['currency code'] = Analytics.normalizeCurrencyCode(product);
        eecFlightAlternative['id'] = Analytics.normalizeId(product);
        eecFlightAlternative['internalId'] = Analytics.normalizeInternalId(product);
        eecFlightAlternative['item_list_id'] = Analytics.normalizeFlightAlternativesList();
        eecFlightAlternative['item_list_name'] = Analytics.normalizeFlightAlternativesList();
        eecFlightAlternative['name'] = Analytics.normalizeName(product);
        eecFlightAlternative['position'] = Analytics.normalizeFlightAlternativesPosition(product);
        eecFlightAlternative['dimension86'] = Analytics.normalizeDimension86(product);
        eecFlightAlternative['dimension18'] = Analytics.normalizeDimension18(product);
        eecFlightAlternative['dimension22'] = Analytics.normalizeDimension22(product);
        eecFlightAlternative['dimension142'] = Analytics.normalizeDimension142(product);
        eecFlightAlternative['dimension89'] = Analytics.normalizeDimension89(product);
        eecFlightAlternative['dimension20'] = Analytics.normalizePackageDimension20(product);
        eecFlightAlternative['dimension16'] = Analytics.normalizeDimension16(product);
        eecFlightAlternative['dimension13'] = Analytics.normalizeDimension13(product);
        eecFlightAlternative['dimension52'] = Analytics.normalizeDimension52(product);
        eecFlightAlternative['dimension15'] = Analytics.normalizeDimension15(product);
        eecFlightAlternative['dimension147'] = Analytics.normalizeDimension147(product, page);
        eecFlightAlternative['price'] = Analytics.normalizePrice(product);
        return eecFlightAlternative;
    };
    Analytics.normalizeSuggestion = function (suggestion, page) {
        var eecSuggestion = {};
        if (suggestion.hasOwnProperty('flight')) {
            eecSuggestion['dimension19'] = Analytics.normalizePackageDimension19(suggestion);
            eecSuggestion['dimension82'] = Analytics.normalizePackageDimension82(suggestion);
            eecSuggestion['dimension2'] = Analytics.normalizeDimension2(suggestion);
            eecSuggestion['dimension34'] = Analytics.normalizeDimension34(suggestion);
            eecSuggestion['dimension136'] = Analytics.normalizeDimension136(suggestion);
            eecSuggestion['dimension135'] = Analytics.normalizeDimension135(suggestion);
            eecSuggestion['dimension35'] = Analytics.normalizeDimension35(suggestion);
            eecSuggestion['dimension81'] = Analytics.normalizeDimension81(suggestion);
            eecSuggestion['dimension78'] = Analytics.normalizeDimension78(suggestion);
            eecSuggestion['dimension37'] = Analytics.normalizeDimension37(suggestion);
            eecSuggestion['dimension74'] = Analytics.normalizeDimension74(suggestion);
            eecSuggestion['dimension138'] = Analytics.normalizeDimension138(suggestion);
            eecSuggestion['dimension38'] = Analytics.normalizeDimension38(suggestion);
            eecSuggestion['dimension32'] = Analytics.normalizeDimension32(suggestion);
            eecSuggestion['dimension29'] = Analytics.normalizeDimension29(suggestion);
            eecSuggestion['dimension24'] = Analytics.normalizeDimension24(suggestion);
            eecSuggestion['dimension33'] = Analytics.normalizeDimension33(suggestion);
            eecSuggestion['dimension26'] = Analytics.normalizeDimension26(suggestion);
            eecSuggestion['dimension140'] = Analytics.normalizeDimension140(suggestion);
            eecSuggestion['dimension27'] = Analytics.normalizeDimension27(suggestion);
            eecSuggestion['dimension141'] = Analytics.normalizeDimension141(suggestion);
            eecSuggestion['dimension28'] = Analytics.normalizeDimension28(suggestion);
            eecSuggestion['dimension70'] = Analytics.normalizeDimension70(suggestion);
            eecSuggestion['dimension56'] = Analytics.normalizeDimension56(suggestion);
            eecSuggestion['dimension67'] = Analytics.normalizeDimension67(suggestion);
            eecSuggestion['dimension42'] = Analytics.normalizeDimension42(suggestion);
            eecSuggestion['dimension53'] = Analytics.normalizeDimension53(suggestion);
            eecSuggestion['brand'] = Analytics.normalizeBrand(suggestion);
            eecSuggestion['category'] = Analytics.normalizeCategory(suggestion);
            eecSuggestion['currency code'] = Analytics.normalizeCurrencyCode(suggestion);
            eecSuggestion['id'] = Analytics.normalizeId(suggestion);
            eecSuggestion['internalId'] = Analytics.normalizeInternalId(suggestion);
            eecSuggestion['item_list_id'] = Analytics.normalizeSuggestionList();
            eecSuggestion['item_list_name'] = Analytics.normalizeSuggestionList();
            eecSuggestion['name'] = Analytics.normalizeName(suggestion);
            eecSuggestion['position'] = Analytics.normalizeSuggestionPosition(suggestion);
            eecSuggestion['dimension86'] = Analytics.normalizeDimension86(suggestion);
            eecSuggestion['dimension18'] = Analytics.normalizeDimension18(suggestion);
            eecSuggestion['dimension22'] = Analytics.normalizeDimension22(suggestion);
            eecSuggestion['dimension142'] = Analytics.normalizeDimension142(suggestion);
            eecSuggestion['dimension89'] = Analytics.normalizeDimension89(suggestion);
            eecSuggestion['dimension20'] = Analytics.normalizePackageDimension20(suggestion);
            eecSuggestion['dimension16'] = Analytics.normalizeDimension16(suggestion);
            eecSuggestion['dimension13'] = Analytics.normalizeDimension13(suggestion);
            eecSuggestion['dimension52'] = Analytics.normalizeDimension52(suggestion);
            eecSuggestion['dimension15'] = Analytics.normalizeDimension15(suggestion);
            eecSuggestion['dimension147'] = Analytics.normalizeDimension147(suggestion, page);
            eecSuggestion['price'] = Analytics.normalizePrice(suggestion);
        }
        else {
            eecSuggestion['dimension19'] = Analytics.normalizeHotelDimension19(suggestion);
            eecSuggestion['dimension82'] = Analytics.normalizeHotelDimension82(suggestion);
            eecSuggestion['dimension2'] = Analytics.normalizeDimension2(suggestion);
            eecSuggestion['dimension32'] = Analytics.normalizeDimension32(suggestion);
            eecSuggestion['dimension29'] = Analytics.normalizeDimension29(suggestion);
            eecSuggestion['dimension24'] = Analytics.normalizeDimension24(suggestion);
            eecSuggestion['dimension33'] = Analytics.normalizeDimension33(suggestion);
            eecSuggestion['dimension26'] = Analytics.normalizeDimension26(suggestion);
            eecSuggestion['dimension140'] = Analytics.normalizeDimension140(suggestion);
            eecSuggestion['dimension27'] = Analytics.normalizeDimension27(suggestion);
            eecSuggestion['dimension141'] = Analytics.normalizeDimension141(suggestion);
            eecSuggestion['dimension28'] = Analytics.normalizeDimension28(suggestion);
            eecSuggestion['dimension70'] = Analytics.normalizeDimension70(suggestion);
            eecSuggestion['dimension56'] = Analytics.normalizeDimension56(suggestion);
            eecSuggestion['dimension67'] = Analytics.normalizeDimension67(suggestion);
            eecSuggestion['dimension42'] = Analytics.normalizeDimension42(suggestion);
            eecSuggestion['brand'] = Analytics.normalizeBrand(suggestion);
            eecSuggestion['category'] = Analytics.normalizeCategory(suggestion);
            eecSuggestion['currency code'] = Analytics.normalizeCurrencyCode(suggestion);
            eecSuggestion['id'] = Analytics.normalizeId(suggestion);
            eecSuggestion['internalId'] = Analytics.normalizeInternalId(suggestion);
            eecSuggestion['item_list_id'] = Analytics.normalizeSuggestionList();
            eecSuggestion['item_list_name'] = Analytics.normalizeName(suggestion);
            eecSuggestion['position'] = Analytics.normalizeSuggestionPosition(suggestion);
            eecSuggestion['dimension86'] = Analytics.normalizeDimension86(suggestion);
            eecSuggestion['dimension18'] = Analytics.normalizeDimension18(suggestion);
            eecSuggestion['dimension22'] = Analytics.normalizeDimension22(suggestion);
            eecSuggestion['dimension142'] = Analytics.normalizeDimension142(suggestion);
            eecSuggestion['dimension89'] = Analytics.normalizeDimension89(suggestion);
            eecSuggestion['dimension20'] = Analytics.normalizeHotelDimension20(suggestion);
            eecSuggestion['dimension16'] = Analytics.normalizeDimension16(suggestion);
            eecSuggestion['dimension13'] = Analytics.normalizeDimension13(suggestion);
            eecSuggestion['dimension52'] = Analytics.normalizeDimension52(suggestion);
            eecSuggestion['dimension15'] = Analytics.normalizeDimension15(suggestion);
            eecSuggestion['dimension147'] = Analytics.normalizeDimension147(suggestion, page);
            eecSuggestion['price'] = Analytics.normalizePrice(suggestion);
        }
        return eecSuggestion;
    };
    Analytics.eecAddToCartPA_HDP = function (availabilityCheck, product, listItemNumber, page) {
        setTimeout(function () {
            var date = new Date();
            var cartProduct = {};
            cartProduct['dimension19'] = Analytics.normalizePackageDimension19(product);
            cartProduct['dimension82'] = Analytics.normalizePackageDimension82(product);
            cartProduct['dimension2'] = Analytics.normalizeDimension2(product);
            cartProduct['dimension34'] = Analytics.normalizeDimension34(product);
            cartProduct['dimension136'] = Analytics.normalizeDimension136(product);
            cartProduct['dimension135'] = Analytics.normalizeDimension135(product);
            cartProduct['dimension35'] = Analytics.normalizeDimension35(product);
            cartProduct['dimension81'] = Analytics.normalizeDimension81(product);
            cartProduct['dimension78'] = Analytics.normalizeDimension78(product);
            cartProduct['dimension37'] = Analytics.normalizeDimension37(product);
            cartProduct['dimension74'] = Analytics.normalizeDimension74(product);
            cartProduct['dimension138'] = Analytics.normalizeDimension138(product);
            cartProduct['dimension38'] = Analytics.normalizeDimension38(product);
            cartProduct['dimension32'] = Analytics.normalizeDimension32(product);
            cartProduct['dimension29'] = Analytics.normalizeDimension29(product);
            cartProduct['dimension24'] = Analytics.normalizeDimension24(product);
            cartProduct['dimension33'] = Analytics.normalizeDimension33(product);
            cartProduct['dimension26'] = Analytics.normalizeDimension26(product);
            cartProduct['dimension140'] = Analytics.normalizeDimension140(product);
            cartProduct['dimension27'] = Analytics.normalizeDimension27(product);
            cartProduct['dimension141'] = Analytics.normalizeDimension141(product);
            cartProduct['dimension28'] = Analytics.normalizeDimension28(product);
            cartProduct['dimension70'] = Analytics.normalizeDimension70(product);
            cartProduct['dimension56'] = Analytics.normalizeDimension56(product);
            cartProduct['dimension67'] = Analytics.normalizeDimension67(product);
            cartProduct['dimension42'] = Analytics.normalizeDimension42(product);
            cartProduct['dimension134'] = Analytics.normalizeDimension134(availabilityCheck);
            cartProduct['dimension53'] = Analytics.normalizeDimension53(product);
            cartProduct['brand'] = Analytics.normalizeBrand(product);
            cartProduct['category'] = Analytics.normalizeCategory(product);
            cartProduct['currency code'] = Analytics.normalizeCurrencyCode(product);
            cartProduct['dimension143'] = Analytics.normalizeDimension143(availabilityCheck);
            cartProduct['id'] = Analytics.normalizeId(product);
            cartProduct['name'] = Analytics.normalizeName(product);
            cartProduct['position'] = listItemNumber + 1;
            cartProduct['dimension86'] = Analytics.normalizeDimension86(product);
            cartProduct['dimension18'] = Analytics.normalizeDimension18(product);
            cartProduct['dimension22'] = Analytics.normalizeDimension22(product);
            cartProduct['dimension142'] = Analytics.normalizeDimension142(product);
            cartProduct['dimension89'] = Analytics.normalizeDimension89(product);
            cartProduct['dimension20'] = Analytics.normalizePackageDimension20(product);
            cartProduct['dimension16'] = Analytics.normalizeDimension16(product);
            cartProduct['dimension13'] = Analytics.normalizeDimension13(product);
            cartProduct['dimension52'] = Analytics.normalizeDimension52(product);
            cartProduct['dimension15'] = Analytics.normalizeDimension15(product);
            cartProduct['price'] = Analytics.normalizePrice(product);
            cartProduct['dimension147'] = Analytics.normalizeDimension147(product, page);
            cartProduct['relaxed_query'] = Analytics.normalizeRelaxedQuery(availabilityCheck);
            cartProduct['item_list_id'] = Analytics.normalizeList();
            cartProduct['item_list_name'] = Analytics.normalizeList();
            dataLayer.push({
                'event': 'eecAddToCartPA',
                'eventCategory': 'EEC',
                'eventAction': 'Add To Cart',
                'eventLabel': date.getFullYear() + '-' + (date.getMonth() + 1),
                'ecommerce': {
                    'currencyCode': 'EUR',
                    'add': {
                        'products': [cartProduct]
                    }
                }
            });
        });
    };
    Analytics.eecAddToCartHT_HDP = function (availabilityCheck, product, listItemNumber, page) {
        setTimeout(function () {
            var date = new Date();
            var cartProduct = {};
            cartProduct['dimension19'] = Analytics.normalizeHotelDimension19(product);
            cartProduct['dimension82'] = Analytics.normalizeHotelDimension82(product);
            cartProduct['dimension2'] = Analytics.normalizeDimension2(product);
            cartProduct['dimension32'] = Analytics.normalizeDimension32(product);
            cartProduct['dimension29'] = Analytics.normalizeDimension29(product);
            cartProduct['dimension24'] = Analytics.normalizeDimension24(product);
            cartProduct['dimension33'] = Analytics.normalizeDimension33(product);
            cartProduct['dimension26'] = Analytics.normalizeDimension26(product);
            cartProduct['dimension140'] = Analytics.normalizeDimension140(product);
            cartProduct['dimension27'] = Analytics.normalizeDimension27(product);
            cartProduct['dimension141'] = Analytics.normalizeDimension141(product);
            cartProduct['dimension28'] = Analytics.normalizeDimension28(product);
            cartProduct['dimension70'] = Analytics.normalizeDimension70(product);
            cartProduct['dimension56'] = Analytics.normalizeDimension56(product);
            cartProduct['dimension67'] = Analytics.normalizeDimension67(product);
            cartProduct['dimension42'] = Analytics.normalizeDimension42(product);
            cartProduct['price'] = Analytics.normalizePrice(product);
            cartProduct['dimension134'] = Analytics.normalizeDimension134(availabilityCheck);
            cartProduct['brand'] = Analytics.normalizeBrand(product);
            cartProduct['category'] = Analytics.normalizeCategory(product);
            cartProduct['dimension143'] = Analytics.normalizeDimension143(availabilityCheck);
            cartProduct['currency code'] = Analytics.normalizeCurrencyCode(product);
            cartProduct['id'] = Analytics.normalizeId(product);
            cartProduct['name'] = Analytics.normalizeName(product);
            cartProduct['position'] = listItemNumber + 1;
            cartProduct['dimension86'] = Analytics.normalizeDimension86(product);
            cartProduct['dimension18'] = Analytics.normalizeDimension18(product);
            cartProduct['dimension22'] = Analytics.normalizeDimension22(product);
            cartProduct['dimension142'] = Analytics.normalizeDimension142(product);
            cartProduct['dimension89'] = Analytics.normalizeDimension89(product);
            cartProduct['dimension20'] = Analytics.normalizeHotelDimension20(product);
            cartProduct['dimension16'] = Analytics.normalizeDimension16(product);
            cartProduct['dimension13'] = Analytics.normalizeDimension13(product);
            cartProduct['dimension52'] = Analytics.normalizeDimension52(product);
            cartProduct['dimension15'] = Analytics.normalizeDimension15(product);
            cartProduct['dimension147'] = Analytics.normalizeDimension147(product, page);
            cartProduct['relaxed_query'] = Analytics.normalizeRelaxedQuery(availabilityCheck);
            cartProduct['item_list_id'] = Analytics.normalizeList();
            cartProduct['item_list_name'] = Analytics.normalizeList();
            dataLayer.push({
                'event': 'eecAddToCartHT',
                'eventCategory': 'EEC',
                'eventAction': 'Add To Cart',
                'eventLabel': date.getFullYear() + '-' + (date.getMonth() + 1),
                'ecommerce': {
                    'currencyCode': 'EUR',
                    'add': {
                        'products': [cartProduct]
                    }
                }
            });
        });
    };
    Analytics.normalizePackageDimension82 = function (product) {
        var travelStart = Analytics.normalizePackageDimension20(product);
        if (travelStart !== "") {
            return differenceInCalendarDays(new Date(travelStart), Date.now());
        }
        return "";
    };
    Analytics.normalizeHotelDimension82 = function (product) {
        var travelStart = Analytics.normalizeHotelDimension20(product);
        if (travelStart !== "") {
            return differenceInCalendarDays(new Date(travelStart), Date.now());
        }
        return "";
    };
    Analytics.normalizeDimension2 = function (product) {
        return localeAction().country;
    };
    Analytics.normalizePackageDimension19 = function (product) {
        var offset = Analytics.normalizePackageDimension82(product);
        if (typeof offset == "number") {
            return Analytics.mapDaysToTravelStartToCluster(offset);
        }
        return "";
    };
    Analytics.normalizeHotelDimension19 = function (product) {
        var offset = Analytics.normalizeHotelDimension82(product);
        if (typeof offset == "number") {
            return Analytics.mapDaysToTravelStartToCluster(offset);
        }
        return "";
    };
    Analytics.normalizeDimension34 = function (product) {
        if (product.hasOwnProperty('flight')
            && product.flight.hasOwnProperty('outbound')
            && product.flight.outbound.hasOwnProperty('departureAirport')
            && product.flight.outbound.departureAirport.hasOwnProperty('code')) {
            return product.flight.outbound.departureAirport.code;
        }
        return "";
    };
    Analytics.normalizeDimension136 = function (product) {
        if (product.hasOwnProperty('flight')
            && product.flight.hasOwnProperty('inbound')
            && product.flight.inbound.hasOwnProperty('airline')
            && product.flight.inbound.airline.hasOwnProperty('code')
            && product.flight.inbound.airline.hasOwnProperty('name')) {
            return product.flight.inbound.airline.code + "_" + product.flight.inbound.airline.name;
        }
        return "";
    };
    Analytics.normalizeDimension135 = function (product) {
        if (product.hasOwnProperty('flight')
            && product.flight.hasOwnProperty('outbound')
            && product.flight.outbound.hasOwnProperty('airline')
            && product.flight.outbound.airline.hasOwnProperty('code')
            && product.flight.outbound.airline.hasOwnProperty('name')) {
            return product.flight.outbound.airline.code + "_" + product.flight.outbound.airline.name;
        }
        return "";
    };
    Analytics.normalizeDimension35 = function (product) {
        if (product.hasOwnProperty('flight')
            && product.flight.hasOwnProperty('outbound')
            && product.flight.outbound.hasOwnProperty('arrivalAirport')
            && product.flight.outbound.arrivalAirport.hasOwnProperty('code')) {
            return product.flight.outbound.arrivalAirport.code;
        }
        return "";
    };
    Analytics.normalizeDimension81 = function (product) {
        if (product.hasOwnProperty('flight')
            && product.flight.hasOwnProperty('inbound')
            && product.flight.inbound.hasOwnProperty('departureDateTime')
            && product.flight.inbound.hasOwnProperty('arrivalDateTime')
            && product.flight.inbound.hasOwnProperty('duration')) {
            var departureDateTime = product.flight.inbound.departureDateTime.replace('T', ' ');
            var arrivalDateTime = product.flight.inbound.arrivalDateTime.replace('T', ' ');
            var duration = product.flight.inbound.duration;
            return departureDateTime + '_' + arrivalDateTime + '_' + duration;
        }
        return "";
    };
    Analytics.normalizeDimension78 = function (product) {
        if (product.hasOwnProperty('flight')
            && product.flight.hasOwnProperty('outbound')
            && product.flight.outbound.hasOwnProperty('departureDateTime')
            && product.flight.outbound.hasOwnProperty('arrivalDateTime')
            && product.flight.outbound.hasOwnProperty('duration')) {
            var departureDateTime = product.flight.outbound.departureDateTime.replace('T', ' ');
            var arrivalDateTime = product.flight.outbound.arrivalDateTime.replace('T', ' ');
            var duration = product.flight.outbound.duration;
            return departureDateTime + '_' + arrivalDateTime + '_' + duration;
        }
        return "";
    };
    Analytics.normalizeDimension37 = function (product) {
        if (product.hasOwnProperty('flight')
            && product.flight.hasOwnProperty('outbound')
            && product.flight.outbound.hasOwnProperty('provider')
            && product.flight.hasOwnProperty('inbound')
            && product.flight.inbound.hasOwnProperty('provider')) {
            return product.flight.outbound.provider + '+' + product.flight.inbound.provider;
        }
        return "";
    };
    Analytics.normalizeDimension74 = function (product) {
        if (product.hasOwnProperty('flight')
            && product.flight.hasOwnProperty('outbound')
            && product.flight.outbound.hasOwnProperty('segments')
            && product.flight.hasOwnProperty('inbound')
            && product.flight.inbound.hasOwnProperty('segments')) {
            return Analytics.mapFlightRouteFromSegments(product.flight.outbound.segments) + '-' +
                Analytics.mapFlightRouteFromSegments(product.flight.inbound.segments);
        }
        return "";
    };
    Analytics.normalizeDimension138 = function (product) {
        if (product.hasOwnProperty('flight')
            && product.flight.hasOwnProperty('outbound')
            && product.flight.outbound.hasOwnProperty('segments')
            && product.flight.hasOwnProperty('inbound')
            && product.flight.inbound.hasOwnProperty('segments')) {
            return Analytics.mapStopoverDurationsFromSegments(product.flight.outbound.segments) + '_' +
                Analytics.mapStopoverDurationsFromSegments(product.flight.inbound.segments);
        }
        return "";
    };
    Analytics.normalizeDimension38 = function (product) {
        if (product.hasOwnProperty('flight')
            && product.flight.hasOwnProperty('outbound')
            && product.flight.outbound.hasOwnProperty('segments')
            && product.flight.hasOwnProperty('inbound')
            && product.flight.inbound.hasOwnProperty('segments')) {
            var outboundSegments = product.flight.outbound.segments;
            var inboundSegments = product.flight.inbound.segments;
            return (outboundSegments.length - 1) + '_' +
                (inboundSegments.length - 1) + '_' +
                Analytics.mapFlightType(outboundSegments, inboundSegments);
        }
        return "";
    };
    Analytics.normalizeDimension32 = function (product) {
        if (product.hasOwnProperty('hotel')
            && product.hotel.hasOwnProperty('board')
            && product.hotel.board.hasOwnProperty('name')
            && product.hotel.board.hasOwnProperty('opCode')
            && product.hotel.board.hasOwnProperty('code')) {
            return product.hotel.board.name + '_' +
                product.hotel.board.opCode + '_' +
                product.hotel.board.code;
        }
        return "";
    };
    Analytics.normalizeDimension29 = function (product) {
        if (product.hasOwnProperty('hotel')
            && product.hotel.hasOwnProperty('category')) {
            return product.hotel.category;
        }
        return "";
    };
    Analytics.normalizeDimension24 = function (product) {
        if (product.hasOwnProperty('hotel')
            && product.hotel.hasOwnProperty('location')
            && product.hotel.location.hasOwnProperty('city')
            && product.hotel.location.city.hasOwnProperty('name')) {
            return product.hotel.location.city.name;
        }
        return "";
    };
    Analytics.normalizeDimension33 = function (product) {
        if (product.hasOwnProperty('hotel')
            && product.hotel.hasOwnProperty('productCode')) {
            return product.hotel.productCode;
        }
        return "";
    };
    Analytics.normalizeDimension26 = function (product) {
        if (product.hasOwnProperty('hotel')
            && product.hotel.hasOwnProperty('location')
            && product.hotel.location.hasOwnProperty('country')
            && product.hotel.location.country.hasOwnProperty('name')) {
            return product.hotel.location.country.name;
        }
        return "";
    };
    Analytics.normalizeDimension140 = function (product) {
        if (product.hasOwnProperty('hotel')
            && product.hotel.hasOwnProperty('location')
            && product.hotel.location.hasOwnProperty('latitude')
            && product.hotel.location.hasOwnProperty('longitude')) {
            return product.hotel.location.latitude + '_' + product.hotel.location.longitude;
        }
        return "";
    };
    Analytics.normalizeDimension27 = function (product) {
        if (product.hasOwnProperty('hotel')
            && product.hotel.hasOwnProperty('name')) {
            return product.hotel.name;
        }
        return "";
    };
    Analytics.normalizeDimension141 = function (product) {
        if (product.hasOwnProperty('properties')
            && product.properties.hasOwnProperty('nearestAirportCode')) {
            return product.properties.nearestAirportCode;
        }
        return "";
    };
    Analytics.normalizeDimension28 = function (product) {
        if (product.hasOwnProperty('hotel')
            && product.hotel.hasOwnProperty('provider')) {
            return product.hotel.provider;
        }
        return "";
    };
    Analytics.normalizeDimension70 = function (product) {
        if (product.hasOwnProperty('hotel')
            && product.hotel.hasOwnProperty('recommendations')) {
            return product.hotel.recommendations.AVERAGE_RATING_TOTAL + '_' +
                product.hotel.recommendations.RATING_COUNT + '_' +
                product.hotel.recommendations.RECOMMENDATIONS_TOTAL;
        }
        return "";
    };
    Analytics.normalizeDimension56 = function (product) {
        if (product.hasOwnProperty('hotel')
            && product.hotel.hasOwnProperty('location')
            && product.hotel.location.hasOwnProperty('region')
            && product.hotel.location.region.hasOwnProperty('name')) {
            return product.hotel.location.region.name;
        }
        return "";
    };
    Analytics.normalizeDimension67 = function (product) {
        if (product.hasOwnProperty('hotel')
            && product.hotel.hasOwnProperty('room')
            && product.hotel.room.hasOwnProperty('name')
            && product.hotel.room.hasOwnProperty('bookingCode')
            && product.hotel.room.hasOwnProperty('code')) {
            return product.hotel.room.name + '_' +
                product.hotel.room.bookingCode + '_' +
                product.hotel.room.code;
        }
        return "";
    };
    Analytics.normalizeDimension43 = function (product) {
        if (product.hasOwnProperty('travellers')
            && product.travellers.hasOwnProperty('travellerRefs')
            && product.hasOwnProperty('price')
            && product.price.hasOwnProperty('pricesPerPerson')) {
            var amountPerAgeGroup_1 = { "ADULT": "nV", "CHILD": "nV", "INFANT": "nV" };
            product.travellers.travellerRefs.forEach(function (traveller) {
                var ageGroup = Analytics.mapAgeToAgeGroup(traveller.age);
                product.price.pricesPerPerson.forEach(function (person) {
                    if (person.refId !== undefined
                        && person.refId !== null
                        && traveller.refId !== undefined
                        && traveller.refId !== null
                        && person.refId === traveller.refId) {
                        amountPerAgeGroup_1[ageGroup] = person.amount.toFixed(2);
                        return;
                    }
                });
            });
            return Object.values(amountPerAgeGroup_1).join('_');
        }
        return "";
    };
    Analytics.normalizeDimension42 = function (product) {
        if (product.hasOwnProperty('price')
            && product.price.hasOwnProperty('amountTotal')
            && product.hasOwnProperty('travellers')
            && product.travellers.hasOwnProperty('travellerRefs')) {
            return (product.price.amountTotal / product.travellers.travellerRefs.length);
        }
        return 0;
    };
    Analytics.normalizeDimension53 = function (product) {
        if (product.hasOwnProperty('properties')
            && product.properties.hasOwnProperty('x-accom-price')
            && product.properties.hasOwnProperty('x-flight-price')
            && product.hasOwnProperty('travellers')
            && product.travellers.hasOwnProperty('travellerRefs')) {
            return product.properties["x-accom-price"] + '_' + product.properties["x-flight-price"];
        }
        return "";
    };
    Analytics.normalizeBrand = function (product) {
        if (product.hasOwnProperty('tourOperator')
            && product.tourOperator.hasOwnProperty('code')) {
            switch (product.tourOperator.code) {
                case "TUID":
                case "NPTU":
                case "NTUI":
                case "ATID":
                    return "TUI";
                case "TUR3":
                case "TUR1":
                case "NPTUR1":
                case "NHTUR1":
                    return "LTUR";
                case "LOC3":
                    return "FLYLOCO";
                case "FTI":
                case "5VF":
                    return "FTI";
                case "EWH":
                case "EWHX":
                    return "EWH";
                case "SLR":
                    return "SLR";
                default:
                    return product.tourOperator.code;
            }
        }
        return "";
    };
    Analytics.normalizeCategory = function (product) {
        if (product.hasOwnProperty('flight')) {
            return "Pauschal";
        }
        else if (product.hasOwnProperty('hotel')) {
            return "Hotel Only";
        }
        return "";
    };
    Analytics.normalizeDimension143 = function (availabilityCheck) {
        var _a;
        var ErrorType = 'noValue';
        if (availabilityCheck.availability == "UNAVAILABLE") {
            ErrorType = 'no message';
            for (var i = 0; i < ((_a = availabilityCheck.messages) === null || _a === void 0 ? void 0 : _a.length); i++) {
                var message = availabilityCheck.messages[i];
                var ErrorCode = message.code;
                var ErrorMessage = message.text;
                if (i != 0) {
                    ErrorType += '#';
                }
                ErrorType += ErrorCode + ' ' + ErrorMessage;
            }
        }
        return ErrorType;
    };
    Analytics.normalizeRelaxedQuery = function (availabilityCheck) {
        var _a, _b, _c, _d;
        var relaxedAlternativeOffer = availabilityCheck === null || availabilityCheck === void 0 ? void 0 : availabilityCheck.relaxedAlternativeOffer;
        var originalPrice = (_a = availabilityCheck === null || availabilityCheck === void 0 ? void 0 : availabilityCheck.originalPrice) === null || _a === void 0 ? void 0 : _a.amount;
        var checkedPrice = (_b = availabilityCheck === null || availabilityCheck === void 0 ? void 0 : availabilityCheck.checkedPrice) === null || _b === void 0 ? void 0 : _b.amount;
        var checkedPricePerPerson = (_c = availabilityCheck === null || availabilityCheck === void 0 ? void 0 : availabilityCheck.checkedPricePerPerson) === null || _c === void 0 ? void 0 : _c.amount;
        var priceStatus = availabilityCheck === null || availabilityCheck === void 0 ? void 0 : availabilityCheck.priceStatus;
        var priceChange = checkedPrice - originalPrice;
        var originalOfferCheckedPrice;
        var offerAvailability;
        if (relaxedAlternativeOffer) {
            offerAvailability = availabilityCheck === null || availabilityCheck === void 0 ? void 0 : availabilityCheck.originalOfferAvailability;
            originalOfferCheckedPrice = (_d = availabilityCheck === null || availabilityCheck === void 0 ? void 0 : availabilityCheck.originalOfferCheckedPrice) === null || _d === void 0 ? void 0 : _d.amount;
        }
        else {
            offerAvailability = availabilityCheck === null || availabilityCheck === void 0 ? void 0 : availabilityCheck.availability;
            originalOfferCheckedPrice = 'noValue';
        }
        var relaxedQuery = relaxedAlternativeOffer + '_' + originalPrice + '_' + offerAvailability + '_' + originalOfferCheckedPrice + '_' + checkedPrice + '_' + checkedPricePerPerson + '_' + priceStatus + '_' + priceChange;
        return relaxedQuery;
    };
    Analytics.normalizeCurrencyCode = function (product) {
        if (product.hasOwnProperty('price')
            && product.price.hasOwnProperty('currency')) {
            return product.price.currency;
        }
        return "";
    };
    Analytics.normalizeId = function (product) {
        if (product.hasOwnProperty('hotel')
            && product.hotel.hasOwnProperty('code')) {
            product.trackingId = product.hotel.code.toString();
            return product.trackingId;
        }
        return "";
    };
    Analytics.normalizeInternalId = function (product) {
        if (product.hasOwnProperty('internalId')) {
            return product.internalId.toString();
        }
        return "";
    };
    Analytics.normalizeList = function () {
        var _a = window.location, host = _a.host, pathname = _a.pathname;
        return pathname;
    };
    Analytics.normalizeFlightAlternativesList = function () {
        var _a = window.location, host = _a.host, pathname = _a.pathname;
        return pathname + '*FA';
    };
    Analytics.normalizeSuggestionList = function () {
        var _a = window.location, host = _a.host, pathname = _a.pathname;
        return pathname + '*ET';
    };
    Analytics.normalizeName = function (product) {
        if (product.hasOwnProperty('properties')
            && product.properties.hasOwnProperty('nearestAirportCode')) {
            return product.properties.nearestAirportCode;
        }
        return "";
    };
    Analytics.normalizePosition = function (product) {
        product.trackingPosition = ++Analytics.productTrackingPosition;
        return product.trackingPosition;
    };
    Analytics.normalizeFlightAlternativesPosition = function (product) {
        product.trackingPosition = ++Analytics.flightAlternativesTrackingPosition;
        return product.trackingPosition;
    };
    Analytics.normalizeSuggestionPosition = function (suggestion) {
        suggestion.trackingPosition = ++Analytics.suggestionTrackingPosition;
        return suggestion.trackingPosition;
    };
    Analytics.normalizeDimension86 = function (product) {
        if (product.hasOwnProperty('provider')) {
            return product.provider;
        }
        return "";
    };
    Analytics.normalizeDimension18 = function (product) {
        if (product.hasOwnProperty('travelPeriod')
            && product.travelPeriod.hasOwnProperty('duration')) {
            return product.travelPeriod.duration;
        }
        return "";
    };
    Analytics.normalizeDimension22 = function (product) {
        if (product.hasOwnProperty('travelPeriod')
            && product.travelPeriod.hasOwnProperty('returnDate')) {
            return product.travelPeriod.returnDate;
        }
        return "";
    };
    Analytics.normalizeDimension142 = function (product) {
        if (product.hasOwnProperty('travelPeriod')) {
            return product.travelPeriod.departureDate.split('-')[1];
        }
        return "";
    };
    Analytics.normalizeDimension89 = function (product) {
        if (product.hasOwnProperty('travelPeriod')
            && product.travelPeriod.hasOwnProperty('departureDate')) {
            var departureDate = new Date(product.travelPeriod.departureDate);
            var departureMonth = departureDate.getMonth() + 1;
            return departureMonth >= 4 && departureMonth <= 10 ? 'Sommer' : 'Winter';
        }
        return "";
    };
    Analytics.normalizePackageDimension20 = function (product) {
        if (product.hasOwnProperty('flight')
            && product.flight.hasOwnProperty('outbound')
            && product.flight.outbound.hasOwnProperty('departureDateTime')) {
            var date = product.flight.outbound.departureDateTime;
            return date.substring(0, date.lastIndexOf('T'));
        }
        return "";
    };
    Analytics.normalizeHotelDimension20 = function (product) {
        if (product.hasOwnProperty('travelPeriod')
            && product.travelPeriod.hasOwnProperty('departureDate')) {
            return product.travelPeriod.departureDate;
        }
        return "";
    };
    Analytics.normalizeDimension16 = function (product) {
        if (product.hasOwnProperty('travellers')
            && product.travellers.hasOwnProperty('travellerRefs')) {
            var adultTravellers = product.travellers.travellerRefs.filter(function (traveller) {
                return traveller.age > 17;
            });
            return adultTravellers.length;
        }
        return 0;
    };
    Analytics.normalizeDimension13 = function (product) {
        if (product.hasOwnProperty('travellers')
            && product.travellers.hasOwnProperty('travellerRefs')) {
            var childTravellers = product.travellers.travellerRefs.filter(function (traveller) {
                return traveller.age >= 2 && traveller.age <= 17;
            });
            return childTravellers.length;
        }
        return 0;
    };
    Analytics.normalizeDimension52 = function (product) {
        if (product.hasOwnProperty('travellers')
            && product.travellers.hasOwnProperty('travellerRefs')) {
            var infantTravellers = product.travellers.travellerRefs.filter(function (traveller) {
                return traveller.age >= 0 && traveller.age <= 1;
            });
            return infantTravellers.length;
        }
        return 0;
    };
    Analytics.normalizeDimension15 = function (product) {
        if (product.hasOwnProperty('travellers')
            && product.travellers.hasOwnProperty('travellerRefs')) {
            return product.travellers.travellerRefs.length;
        }
        return 0;
    };
    Analytics.normalizeDimension147 = function (product, page) {
        var _a;
        if (product.hasOwnProperty('references')
            && product.references.hasOwnProperty('hotelImages')) {
            return 0;
        }
        else {
            if (page !== Analytics.DESTINATION_LIST_PAGE) {
                var HotelImages = document.getElementsByTagName('hotel-gallery-ui');
                var data = ((_a = HotelImages[0]) === null || _a === void 0 ? void 0 : _a.getAttribute('data')) || '';
                return data.includes('hotel-dummy-large.jpg') ? 1 : 0;
            }
            else {
                return 1;
            }
        }
    };
    Analytics.normalizePrice = function (product) {
        if (product.hasOwnProperty('price')
            && product.price.hasOwnProperty('amountTotal')) {
            return product.price.amountTotal;
        }
        return 0;
    };
    Analytics.normalizeDimension134 = function (availabilityCheck) {
        var _a, _b;
        return ((_a = availabilityCheck.checkedPriceWithoutExtras) === null || _a === void 0 ? void 0 : _a.amount) - ((_b = availabilityCheck.originalPrice) === null || _b === void 0 ? void 0 : _b.amount);
    };
    Analytics.mapDaysToTravelStartToCluster = function (offset) {
        switch (true) {
            case offset >= 0 && offset <= 3:
                return "a) 0-3 Tage";
            case offset >= 4 && offset <= 14:
                return "b) 4-14 Tage";
            case offset >= 15 && offset <= 35:
                return "c) 15-35 Tage";
            case offset >= 36 && offset <= 45:
                return "d) 36-45 Tage";
            case offset >= 46 && offset <= 90:
                return "e) 46-90 Tage";
            case offset > 90:
                return "f) >90 Tage";
            default:
                return "";
        }
    };
    Analytics.mapDaysToTravelStartToClusterTUI = function (offset) {
        switch (true) {
            case offset >= 0 && offset <= 10:
                return "a) 0-10 Tage";
            case offset >= 11 && offset <= 30:
                return "b) 11-30 Tage";
            case offset >= 31 && offset <= 60:
                return "c) 31-60 Tage";
            case offset >= 61 && offset <= 90:
                return "d) 61-90 Tage";
            case offset > 90:
                return "e) >90 Tage";
            default:
                return "";
        }
    };
    Analytics.mapFlightRouteFromSegments = function (segments) {
        var route = "";
        segments.forEach(function (segment) {
            route += segment.departureAirport.code + '-';
        });
        return route + segments[segments.length - 1].arrivalAirport.code;
    };
    Analytics.mapStopoverDurationsFromSegments = function (segments) {
        if (segments.length === 1) {
            return 0;
        }
        var stopovers = [];
        var arrivalDate = null;
        segments.forEach(function (segment) {
            if (arrivalDate === null) {
                arrivalDate = segment.arrivalDateTime;
                return;
            }
            var arrivalDateMS = new Date(arrivalDate).getTime();
            var departureDateMS = new Date(segment.departureDateTime).getTime();
            stopovers.push(Math.abs(arrivalDateMS - departureDateMS) / 60 / 1000);
            arrivalDate = segment.arrivalDateTime;
        });
        return stopovers.join(',');
    };
    Analytics.mapFlightType = function (outboundSegments, inboundSegments) {
        var outboundDepartureAirport = outboundSegments[0].departureAirport.code;
        var returnArrivalAirport = inboundSegments[inboundSegments.length - 1].arrivalAirport.code;
        return outboundDepartureAirport === returnArrivalAirport ? 'Normalflug' : 'Gabelflug';
    };
    Analytics.mapAgeToAgeGroup = function (age) {
        switch (true) {
            case age >= 0 && age <= 1:
                return "INFANT";
            case age >= 2 && age <= 17:
                return "CHILD";
            case age > 17:
                return "ADULT";
            default:
                return "UNKNOWN";
        }
    };
    Analytics.eecDetail = function (eecProducts) {
        var date = new Date();
        var hotelOnly = false;
        if (eecProducts[0] && eecProducts[0]['category'] === 'Hotel Only') {
            hotelOnly = true;
        }
        var event = hotelOnly ? 'eecProductDetailView_HT' : 'eecProductDetailView_PA';
        dataLayer.push({
            'event': event,
            'eventCategory': 'EEC',
            'eventAction': 'Detail View',
            'eventLabel': date.getFullYear() + '-' + (date.getMonth() + 1),
            'ecommerce': {
                'detail': {
                    'actionField': { 'list': Analytics.normalizeList() },
                    'products': eecProducts
                }
            }
        });
    };
    Analytics.eecDetailFlightAlternatives = function (eecProducts) {
        dataLayer.push({
            'event': 'eecProdImpressionPA_HD-FA',
            'ecommerce': {
                'items': eecProducts
            }
        });
    };
    Analytics.addBookmark = function (product) {
        dataLayer.push({
            'event': 'add_to_wishlist',
            'ecommerce': {
                'items': [
                    this.normalizeProduct(product, undefined, true)
                ]
            }
        });
    };
    Analytics.removeBookmark = function (product) {
        dataLayer.push({
            'event': 'remove_from_wishlist',
            'ecommerce': {
                'items': [
                    this.normalizeProduct(product, undefined, true)
                ]
            }
        });
    };
    Analytics.suggestionsAvailable = function () {
        dataLayer.push({
            'event': 'empfehlungsteaser_available'
        });
    };
    Analytics.geoTreeGroupIdPath = function (flatProductGroups, productGroupId, productGroupHelper) {
        if (this.productGroupId != productGroupId) {
            var productGroup = flatProductGroups[productGroupId];
            var isLink = productGroup.properties.isLink;
            var eventAction_1 = '';
            var eventLabel_1 = '';
            if (isLink) {
                productGroupId = productGroup.properties.linkTarget;
            }
            productGroupHelper.buildBreadcrumb(productGroupId, flatProductGroups).sequence.forEach(function (item) {
                eventAction_1 += item.name + '_';
                eventLabel_1 += item.id + '_';
            });
            eventAction_1 += flatProductGroups[productGroupId].name;
            eventLabel_1 += productGroupId;
            dataLayer.push({
                'event': 'geoTreeGroupIdPath',
                'event_name': 'geoTreeGroupIdPath',
                'geoTreeGroupIdPath': {
                    'eventCategory': 'geoTreeGroupIdPath',
                    'eventAction': eventAction_1,
                    'eventLabel': eventLabel_1,
                    'groupNamePath': eventAction_1,
                    'groupIdPath': eventLabel_1
                }
            });
            this.productGroupId = productGroupId;
        }
    };
    Analytics.extractFilterData = function (data, modelType) {
        var e_1, _a;
        var _b, _c, _d, _e, _f, _g, _h, _j;
        var setFilter = [];
        switch (data.type) {
            case FilterType.CHECK_BOX_GROUP_FILTER:
                var diff = data.model.reduce(function (p, c, i) {
                    if (c !== data.previousModel[i])
                        p.push(i);
                    return p;
                }, []);
                diff.forEach(function (v) { return setFilter.push({ name: data.identifier, value: data.items[v].name + ':' + data[modelType][v] }); });
                break;
            case FilterType.CHECK_BOX_FILTER:
            case FilterType.RATING_FILTER:
                setFilter.push({ name: data.identifier, value: data[modelType] });
                break;
            case FilterType.RADIO_GROUP_FILTER:
            case FilterType.SELECT_FILTER:
                setFilter.push({ name: data.identifier, value: data.items.find(function (item) { return item.id == data[modelType]; }).name });
                break;
            case FilterType.SLIDER_FILTER:
                setFilter.push({ name: data.identifier, value: data[modelType][1] != undefined ? data[modelType][0] + '_' + data[modelType][1] : data[modelType][0] });
                break;
            case FilterType.SUBMITABLE_FILTER:
                var submitableFilter = '';
                try {
                    for (var _k = __values(Object.entries(data.model)), _l = _k.next(); !_l.done; _l = _k.next()) {
                        var _m = __read(_l.value, 2), key = _m[0], value = _m[1];
                        submitableFilter += key + ':' + value + '*';
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_l && !_l.done && (_a = _k.return)) _a.call(_k);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                setFilter.push({ name: data.identifier, value: submitableFilter.slice(0, -1) });
                break;
            case FilterType.DEPARTURE_AIRPORT_FILTER:
                setFilter.push({ name: data.identifier, value: data.model.map(function (a) { return a.name; }).join('*') || 'beliebig' });
                break;
            case FilterType.DESTIATION_FILTER:
                if (((_c = (_b = data.model) === null || _b === void 0 ? void 0 : _b.reference) === null || _c === void 0 ? void 0 : _c.value) != undefined) {
                    setFilter.push({ name: data.identifier, value: ((_e = (_d = data.model) === null || _d === void 0 ? void 0 : _d.reference) === null || _e === void 0 ? void 0 : _e.value) + '_' + ((_f = data.model) === null || _f === void 0 ? void 0 : _f.value) });
                }
                else {
                    setFilter.push({ name: data.identifier, value: ((_h = (_g = data.model) === null || _g === void 0 ? void 0 : _g.group) === null || _h === void 0 ? void 0 : _h.id) + '_' + ((_j = data.model) === null || _j === void 0 ? void 0 : _j.value) });
                }
                break;
            default:
                setFilter.push({ name: data.identifier, value: data.model });
                break;
        }
        return setFilter;
    };
    Analytics.dataLayerFilter = function (productCategory, filterCategory, filterName, filterValue) {
        //@ts-ignore
        if (window.dataLayer) {
            dataLayer.push({
                event: "ga4event",
                event_name: "filter",
                filter: {
                    event_category: "filter",
                    event_action: productCategory.toLowerCase() + '*' + filterCategory + ':' + filterName,
                    event_label: filterValue,
                    productCategory: productCategory.toLowerCase(),
                    filterCategory: filterCategory,
                    filterName: filterName,
                    filterValue: filterValue
                }
            });
        }
    };
    Analytics.trackSearchmaskCTA = function (data, productType) {
        var e_2, _a;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4;
        var origin = ((_b = data === null || data === void 0 ? void 0 : data.departureAirportFilter) === null || _b === void 0 ? void 0 : _b.model.map(function (a) { return a.name; }).join(',')) || 'beliebig';
        var transfer = (_c = data === null || data === void 0 ? void 0 : data.transferFilter) === null || _c === void 0 ? void 0 : _c.model;
        var price = ((_d = data === null || data === void 0 ? void 0 : data.priceFilter) === null || _d === void 0 ? void 0 : _d.model[0]) ? ((_e = data === null || data === void 0 ? void 0 : data.priceFilter) === null || _e === void 0 ? void 0 : _e.model[0]) + '_' + ((_f = data === null || data === void 0 ? void 0 : data.priceFilter) === null || _f === void 0 ? void 0 : _f.model[1]) : undefined;
        var board = (_g = data === null || data === void 0 ? void 0 : data.hotelBoardCodesFilter) === null || _g === void 0 ? void 0 : _g.items.find(function (item) { var _a; return item.id == ((_a = data === null || data === void 0 ? void 0 : data.hotelBoardCodesFilter) === null || _a === void 0 ? void 0 : _a.model); }).name;
        var hotelCategory = (_h = data === null || data === void 0 ? void 0 : data.hotelCategoryFilter) === null || _h === void 0 ? void 0 : _h.items.find(function (item) { var _a; return item.id == ((_a = data === null || data === void 0 ? void 0 : data.hotelCategoryFilter) === null || _a === void 0 ? void 0 : _a.model); }).name;
        var startDate = data.datePickerFilter.model.start;
        var endDate = data.datePickerFilter.model.end;
        var daysToStfStart = differenceInCalendarDays(startDate, new Date());
        var window = differenceInCalendarDays(endDate, startDate);
        var duration = data.datePickerFilter.model.period;
        var exact = !data.datePickerFilter.model.flexible;
        var period_ltur = this.mapDaysToTravelStartToCluster(daysToStfStart);
        var period_tui = this.mapDaysToTravelStartToClusterTUI(daysToStfStart);
        var departureMonth = new Date(startDate).getMonth() + 1;
        var season = departureMonth >= 4 && departureMonth <= 10 ? 'Sommer' : 'Winter';
        var adults = data.travellersFilter.model.adults;
        var children = 0;
        var infants = 0;
        try {
            for (var _5 = __values(data.travellersFilter.model.children), _6 = _5.next(); !_6.done; _6 = _5.next()) {
                var childage = _6.value;
                if (this.mapAgeToAgeGroup(childage) == 'INFANT') {
                    infants++;
                }
                else if (this.mapAgeToAgeGroup(childage) == 'CHILD') {
                    children++;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_6 && !_6.done && (_a = _5.return)) _a.call(_5);
            }
            finally { if (e_2) throw e_2.error; }
        }
        var pax = adults + children + infants;
        var group = "";
        if (children >= 1 || infants >= 1) {
            group = 'family';
        }
        else if (adults == 2) {
            group = 'couple';
        }
        else if (adults == 1) {
            group = 'single';
        }
        else if (adults >= 3) {
            group = 'group';
        }
        var destination;
        var destType;
        if ((_m = (_l = (_k = (_j = data === null || data === void 0 ? void 0 : data.destinationFilter) === null || _j === void 0 ? void 0 : _j.model) === null || _k === void 0 ? void 0 : _k.reference) === null || _l === void 0 ? void 0 : _l.type) === null || _m === void 0 ? void 0 : _m.includes('HOTEL')) {
            destType = 'hotel_';
        }
        else {
            destType = 'destination_';
        }
        if ((_q = (_p = (_o = data === null || data === void 0 ? void 0 : data.destinationFilter) === null || _o === void 0 ? void 0 : _o.model) === null || _p === void 0 ? void 0 : _p.reference) === null || _q === void 0 ? void 0 : _q.value) {
            destination = ((_s = (_r = data === null || data === void 0 ? void 0 : data.destinationFilter) === null || _r === void 0 ? void 0 : _r.model) === null || _s === void 0 ? void 0 : _s.length) == 0 ? 'beliebig' : destType + ((_v = (_u = (_t = data === null || data === void 0 ? void 0 : data.destinationFilter) === null || _t === void 0 ? void 0 : _t.model) === null || _u === void 0 ? void 0 : _u.reference) === null || _v === void 0 ? void 0 : _v.value) + '_' + ((_x = (_w = data === null || data === void 0 ? void 0 : data.destinationFilter) === null || _w === void 0 ? void 0 : _w.model) === null || _x === void 0 ? void 0 : _x.value);
        }
        else {
            destination = ((_z = (_y = data === null || data === void 0 ? void 0 : data.destinationFilter) === null || _y === void 0 ? void 0 : _y.model) === null || _z === void 0 ? void 0 : _z.length) == 0 ? 'beliebig' : destType + ((_2 = (_1 = (_0 = data === null || data === void 0 ? void 0 : data.destinationFilter) === null || _0 === void 0 ? void 0 : _0.model) === null || _1 === void 0 ? void 0 : _1.group) === null || _2 === void 0 ? void 0 : _2.id) + '_' + ((_4 = (_3 = data === null || data === void 0 ? void 0 : data.destinationFilter) === null || _3 === void 0 ? void 0 : _3.model) === null || _4 === void 0 ? void 0 : _4.value);
        }
        var travelPeriod = startDate + "_" + endDate + "_" + daysToStfStart + "_" + duration + "_" + exact + "_" + window + "_" + period_tui + "_" + period_ltur + "_" + season;
        var travellers = adults + "_" + children + "_" + infants + "_" + pax + "_" + group;
        dataLayer.push({
            event: "ga4event",
            event_name: "filter",
            filter: {
                event_category: "filter",
                event_action: productType.toLowerCase() + '_searchCTA',
                event_label: destination + "*" + origin + "*" + travelPeriod + "*" + travellers + "*" + hotelCategory + "*" + board + "*" + price + "*" + transfer,
                productCategory: productType.toLowerCase(),
                filterCategory: "searchCTA",
                reisezielHotel: destination,
                abflughafen: origin,
                reisezeitraum: travelPeriod,
                reisende: travellers,
                hotelkategorie: hotelCategory,
                verpflegung: board,
                gesamtpreis: price,
                transfer: transfer
            }
        });
    };
    Analytics.trackRemoveAllFilters = function (data) {
        var e_3, _a;
        var lturState = store.getState();
        var productType = lturState.websiteState.app.url.context.productType;
        var removedFilters = '';
        try {
            for (var data_1 = __values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
                var filter = data_1_1.value;
                removedFilters += this.extractFilterData(filter, 'previousModel').reduce(function (p, c) { return p + c.name + ':' + c.value + '*'; }, '');
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        removedFilters = removedFilters.slice(0, -1);
        this.dataLayerFilter(productType, 'summeryDeselect', 'alle löschen', removedFilters);
    };
    Analytics.trackFilterChange = function (data) {
        var lturState = store.getState();
        var productType = lturState.websiteState.app.url.context.productType;
        if (data.identifier != undefined) {
            var _a = this.extractFilterData(data, 'model')[0], name = _a.name, value = _a.value;
            if (name != undefined && value != undefined) {
                this.dataLayerFilter(productType, data.type, name, value);
            }
        }
    };
    Analytics.productGroupId = '';
    Analytics.productTrackingPosition = 0;
    Analytics.flightAlternativesTrackingPosition = 0;
    Analytics.suggestionTrackingPosition = 0;
    Analytics.HOTEL_DETAIL_PAGE = 'HOTEL_DETAIL_PAGE';
    Analytics.DESTINATION_LIST_PAGE = 'DESTINATION_LIST_PAGE';
    return Analytics;
}());
export default Analytics;
